export const graphPromoteInstallmentsConfiguration = {
  minimumPrice: 50,
  numberOfInstallments: 3,
}
